/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_Memory_DInputs */

const en_mk_nav_p_memory_d = /** @type {(inputs: Mk_Nav_P_Memory_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rules, prices and tone of voice, reused on every run.`)
};

const id_mk_nav_p_memory_d = /** @type {(inputs: Mk_Nav_P_Memory_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aturan, harga, dan nada bicara yang dipakai ulang.`)
};

/**
* | output |
* | --- |
* | "Rules, prices and tone of voice, reused on every run." |
*
* @param {Mk_Nav_P_Memory_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_memory_d = /** @type {((inputs?: Mk_Nav_P_Memory_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_Memory_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_memory_d(inputs)
	return en_mk_nav_p_memory_d(inputs)
});